import { render, staticRenderFns } from "./StoryTeaser.vue?vue&type=template&id=e6370b60&scoped=true&"
import script from "./StoryTeaser.vue?vue&type=script&lang=js&"
export * from "./StoryTeaser.vue?vue&type=script&lang=js&"
import style0 from "./StoryTeaser.vue?vue&type=style&index=0&id=e6370b60&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6370b60",
  null
  
)

export default component.exports